import { Box, Heading, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { CommentSubjectKind } from "../../../../../../autogen/bff-api";
import { useCommentRounds } from "./CommentRoundContext";
import { ItemComments } from "./ItemComments";

interface Props {
  kind: CommentSubjectKind;
  title: string;
  items: { ref: string; label: string }[];
}

export const SubjectCommentsSection = ({ kind, title, items }: Props) => {
  const { t } = useTranslation();
  const rounds = useCommentRounds();
  const comments = rounds?.comments?.filter((comment) => comment.kind === kind) ?? [];
  if (comments.length === 0) return null;
  const commented = items.filter((item) => comments.some((comment) => comment.ref === item.ref));
  const removedCount = comments.filter((comment) => !items.some((item) => item.ref === comment.ref)).length;

  return (
    <Box borderWidth="1px" borderColor="smBorder" borderRadius="lg" p="4" mb="6" data-testid="subject-comments-section">
      <Heading as="h3" size="sm" mb="3">
        {title}
      </Heading>
      <Stack spacing="3">
        {commented.map((item) => (
          <Box key={item.ref}>
            <Text fontSize="sm" fontWeight="semibold">
              {item.label}
            </Text>
            <ItemComments kind={kind} itemRef={item.ref} defaultOpen />
          </Box>
        ))}
        {removedCount > 0 && (
          <Text fontSize="sm" color="smMuted">
            {t(
              "{{count}} comments concern items no longer in the procurement. Open the market dialogue to read them.",
              { count: removedCount },
            )}
          </Text>
        )}
      </Stack>
    </Box>
  );
};
